import { render } from "./PageNotFoundView.vue?vue&type=template&id=0060387b"
import script from "./PageNotFoundView.vue?vue&type=script&lang=js"
export * from "./PageNotFoundView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__